export const SIGN_IN = 'SIGN_IN';
export const AZURE_LOGIN = 'AZURE_LOGIN';
export const FIRST_REGISTER = 'FIRST_REGISTER';
export const COMPANY_FILTER = 'COMPANY_FILTER';
export const INITIAL_LOGIN = 'INITIAL_LOGIN';
